var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-2" },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-3", attrs: { cols: "12", md: "12" } },
            [
              _c(
                "v-card",
                { staticClass: "mb-3", attrs: { flat: "", outlined: "" } },
                [
                  _c("v-card-title", [_vm._v("Network Metrics")]),
                  _c(
                    "v-card-text",
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.networkMetricsHeaders,
                          items: _vm.networkMetricsItems,
                          "hide-default-footer": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-3", attrs: { cols: "12", md: "12" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card",
                    { attrs: { height: "240" } },
                    [
                      _c("ProjectDiagram", {
                        attrs: { network: _vm.diagramNetwork },
                        on: {
                          "update:network": function ($event) {
                            _vm.diagramNetwork = $event
                          },
                          "update-breakers": _vm.updateBreakers,
                          "click-switch": _vm.updateSwitch,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            "x-small": "",
                            rounded: "",
                            outlined: "",
                            color: "primary",
                            to: {
                              name: "CaseVis",
                              hash: "#NetworkDiagram",
                              params: {
                                id: _vm.currentCase.id,
                                folderId: _vm.computedFolderId,
                              },
                            },
                          },
                        },
                        [_vm._v("Open diagram")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "12" } },
            [
              _c(
                "Aggregate",
                _vm._b(
                  {
                    attrs: {
                      title: "Nodes",
                      ItemConstructor: _vm.nodeFactory,
                      "item-defaults": _vm.nodeDefault,
                      headers: _vm.nodeHeaders,
                      "copy-btn": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.rated_voltage",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  hint: _vm.schemaNode.rated_voltage.title,
                                  suffix: _vm.schemaNode.rated_voltage.unit,
                                  type: "number",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.rated_voltage,
                                  callback: function ($$v) {
                                    _vm.$set(item, "rated_voltage", _vm._n($$v))
                                  },
                                  expression: "item.rated_voltage",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.max_voltage",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  hint: _vm.schemaNode.max_voltage.title,
                                  suffix: _vm.schemaNode.max_voltage.unit,
                                  type: "number",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.max_voltage,
                                  callback: function ($$v) {
                                    _vm.$set(item, "max_voltage", _vm._n($$v))
                                  },
                                  expression: "item.max_voltage",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.min_voltage",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  hint: _vm.schemaNode.min_voltage.title,
                                  suffix: _vm.schemaNode.min_voltage.unit,
                                  type: "number",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.min_voltage,
                                  callback: function ($$v) {
                                    _vm.$set(item, "min_voltage", _vm._n($$v))
                                  },
                                  expression: "item.min_voltage",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.active",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.schemaNode.active.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.active,
                                  callback: function ($$v) {
                                    _vm.$set(item, "active", $$v)
                                  },
                                  expression: "item.active",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "v-card",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("InputGeo", {
                                        attrs: { icon: item.icon },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append-row",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "InputGeneric",
                                                    {
                                                      attrs: {
                                                        label: "Icon",
                                                        "label-size": 1,
                                                      },
                                                    },
                                                    [
                                                      _c("InputIcon", {
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.icon,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "icon",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.icon",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.coordinates,
                                          callback: function ($$v) {
                                            _vm.$set(item, "coordinates", $$v)
                                          },
                                          expression: "item.coordinates",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedInput.nodes,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "nodes", $$v)
                      },
                      expression: "computedInput.nodes",
                    },
                  },
                  "Aggregate",
                  _vm.$attrs,
                  false
                )
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "12" } },
            [
              _c(
                "Aggregate",
                _vm._b(
                  {
                    attrs: {
                      title: "Branches",
                      ItemConstructor: _vm.branchFactory,
                      headers: _vm.branchHeaders,
                      "copy-btn": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.node_from",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  hint: _vm.schemaBranch.node_from.tooltip,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.node_from,
                                  callback: function ($$v) {
                                    _vm.$set(item, "node_from", $$v)
                                  },
                                  expression: "item.node_from",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.node_to",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  hint: _vm.schemaBranch.node_to.tooltip,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.node_to,
                                  callback: function ($$v) {
                                    _vm.$set(item, "node_to", $$v)
                                  },
                                  expression: "item.node_to",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.length",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  suffix: _vm.schemaBranch.length.unit,
                                  type: "number",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.length,
                                  callback: function ($$v) {
                                    _vm.$set(item, "length", _vm._n($$v))
                                  },
                                  expression: "item.length",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.standard_type",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.lineStandardTypesNames,
                                  label: _vm.schemaBranch.standard_type.title,
                                  clearable: "",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.standardType(item.id, "branches")
                                  },
                                },
                                model: {
                                  value: item.standard_type,
                                  callback: function ($$v) {
                                    _vm.$set(item, "standard_type", $$v)
                                  },
                                  expression: "item.standard_type",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.active",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.schemaBranch.active.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.active,
                                  callback: function ($$v) {
                                    _vm.$set(item, "active", $$v)
                                  },
                                  expression: "item.active",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "v-card",
                                { staticClass: "mb-3" },
                                [
                                  _c("v-card-title", [
                                    _c("h6", { staticClass: "text-h6" }, [
                                      _vm._v("Parameters"),
                                    ]),
                                  ]),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .reactance.title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .reactance.unit,
                                                          type: "number",
                                                          disabled: _vm.disable,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.reactance,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "reactance",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.reactance",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .capacitance
                                                              .title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .capacitance.unit,
                                                          type: "number",
                                                          disabled: _vm.disable,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.capacitance,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "capacitance",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.capacitance",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .max_thermal_current
                                                              .title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .max_thermal_current
                                                              .unit,
                                                          type: "number",
                                                          disabled: _vm.disable,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.max_thermal_current,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "max_thermal_current",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.max_thermal_current",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .max_loading_percent
                                                              .title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .max_loading_percent
                                                              .unit,
                                                          type: "number",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.max_loading_percent,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "max_loading_percent",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.max_loading_percent",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .resistance.title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .resistance.unit,
                                                          type: "number",
                                                          disabled: _vm.disable,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.resistance,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "resistance",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.resistance",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        md: "6",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaBranch
                                                              .voltage.title,
                                                          suffix:
                                                            _vm.schemaBranch
                                                              .voltage.unit,
                                                          type: "number",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.voltage,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "voltage",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.voltage",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("InputYearly", {
                                                attrs: {
                                                  label:
                                                    _vm.schemaBranch.capacity
                                                      .title,
                                                  num_years: _vm.num_years,
                                                  suffix:
                                                    _vm.schemaBranch.capacity
                                                      .unit,
                                                  "spread-values": "",
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.schemaBranch.capacity
                                                      .items.default,
                                                  "start-year":
                                                    _vm.currentCase.settings
                                                      .year_start,
                                                  type: "number",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.capacity,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "capacity",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.capacity",
                                                },
                                              }),
                                              _c("v-switch", {
                                                attrs: {
                                                  label: "Run contingency",
                                                  hint: "Consider this branch in an n-1 contingency analysis",
                                                  "persistent-hint": "",
                                                },
                                                model: {
                                                  value: item.run_contingency,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "run_contingency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.run_contingency",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "h6",
                                                { staticClass: "text-h6" },
                                                [
                                                  _vm._v(" Transmission Line "),
                                                  _c(
                                                    "Dialog",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          icon: "edit",
                                                          tooltip:
                                                            "Edit transmission line",
                                                          width: 500,
                                                          title:
                                                            "Transmission Line",
                                                          body: {
                                                            component:
                                                              _vm.inputCoordinates,
                                                            props: {
                                                              value:
                                                                item.coordinates,
                                                              headers: [
                                                                {
                                                                  name: "Lat",
                                                                  editable: true,
                                                                },
                                                                {
                                                                  name: "Lon",
                                                                  editable: true,
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        },
                                                      },
                                                      _vm.$listeners
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "LMap",
                                                {
                                                  ref: "branch-" + item.id,
                                                  staticStyle: {
                                                    "z-index": "0",
                                                  },
                                                  attrs: {
                                                    options: {
                                                      attributionControl: false,
                                                    },
                                                  },
                                                  on: {
                                                    ready: function ($event) {
                                                      return _vm.centerMap(
                                                        "branch-" + item.id,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("LTileLayer", {
                                                    attrs: { url: _vm.mapUrl },
                                                  }),
                                                  _vm.getNode(item.node_from)
                                                    ? _c(
                                                        "LMarker",
                                                        {
                                                          attrs: {
                                                            "lat-lng":
                                                              _vm.getNode(
                                                                item.node_from
                                                              ).coordinates,
                                                            icon: _vm.circleIcon(
                                                              _vm.getNode(
                                                                item.node_from
                                                              ).icon,
                                                              "black"
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "LTooltip",
                                                            {
                                                              attrs: {
                                                                options: {
                                                                  permanent: true,
                                                                  interactive: true,
                                                                  direction:
                                                                    "top",
                                                                  offset:
                                                                    _vm.point(
                                                                      0,
                                                                      -20
                                                                    ),
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getNode(
                                                                        item.node_from
                                                                      ).name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.getNode(item.node_to)
                                                    ? _c(
                                                        "LMarker",
                                                        {
                                                          attrs: {
                                                            "lat-lng":
                                                              _vm.getNode(
                                                                item.node_to
                                                              ).coordinates,
                                                            icon: _vm.circleIcon(
                                                              _vm.getNode(
                                                                item.node_to
                                                              ).icon,
                                                              "black"
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "LTooltip",
                                                            {
                                                              attrs: {
                                                                options: {
                                                                  permanent: true,
                                                                  interactive: true,
                                                                  direction:
                                                                    "top",
                                                                  offset:
                                                                    _vm.point(
                                                                      0,
                                                                      -20
                                                                    ),
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getNode(
                                                                        item.node_to
                                                                      ).name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c("LPolyline", {
                                                    attrs: {
                                                      "lat-lngs":
                                                        _vm.getBranchCoordinates(
                                                          item
                                                        ),
                                                      color: "#424242",
                                                    },
                                                  }),
                                                  _c(
                                                    "LControl",
                                                    {
                                                      staticClass:
                                                        "logo-control-2",
                                                      attrs: {
                                                        position: "bottomright",
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "logo-2",
                                                        attrs: {
                                                          src: require("@/assets/rex-logo.png"),
                                                          alt: "Acelerex",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-card-title", [
                                    _c("h6", { staticClass: "text-h6" }, [
                                      _vm._v("Short Circuit Parameters"),
                                    ]),
                                  ]),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaBranch.end_temperature
                                              .title,
                                          hint: _vm.schemaBranch.end_temperature
                                            .tooltip,
                                          suffix:
                                            _vm.schemaBranch.end_temperature
                                              .unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.end_temperature,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "end_temperature",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.end_temperature",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedInput.branches,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "branches", $$v)
                      },
                      expression: "computedInput.branches",
                    },
                  },
                  "Aggregate",
                  _vm.$attrs,
                  false
                )
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "12" } },
            [
              _c(
                "Aggregate",
                _vm._b(
                  {
                    attrs: {
                      title: "Transformers",
                      ItemConstructor: _vm.transformerFactory,
                      headers: _vm.transformerHeaders,
                      "copy-btn": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.winding",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.windingDropDown,
                                  "item-text": "text",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.winding,
                                  callback: function ($$v) {
                                    _vm.$set(item, "winding", $$v)
                                  },
                                  expression: "item.winding",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.high_voltage_node",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.high_voltage_node,
                                  callback: function ($$v) {
                                    _vm.$set(item, "high_voltage_node", $$v)
                                  },
                                  expression: "item.high_voltage_node",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.low_voltage_node",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.low_voltage_node,
                                  callback: function ($$v) {
                                    _vm.$set(item, "low_voltage_node", $$v)
                                  },
                                  expression: "item.low_voltage_node",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.medium_voltage_node",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  disabled: !(item.winding === "three"),
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.medium_voltage_node,
                                  callback: function ($$v) {
                                    _vm.$set(item, "medium_voltage_node", $$v)
                                  },
                                  expression: "item.medium_voltage_node",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.standard_type",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items:
                                    item.winding === "two"
                                      ? _vm.transformerStandardTypesNames
                                      : _vm.transformer3wStandardTypesNames,
                                  label:
                                    _vm.schemaTransformer.standard_type.title,
                                  "single-line": "",
                                  clearable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.standardType(
                                      item.id,
                                      "transformers"
                                    )
                                  },
                                },
                                model: {
                                  value: item.standard_type,
                                  callback: function ($$v) {
                                    _vm.$set(item, "standard_type", $$v)
                                  },
                                  expression: "item.standard_type",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "v-card",
                                { staticClass: "mb-3" },
                                [
                                  _c("v-card-title", [
                                    _c("h6", { staticClass: "text-h6" }, [
                                      _vm._v("Parameters"),
                                    ]),
                                  ]),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c("v-switch", {
                                            staticClass: "mr-8 mb-4",
                                            attrs: {
                                              label:
                                                _vm.schemaTransformer.active
                                                  .title,
                                              dense: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.active,
                                              callback: function ($$v) {
                                                _vm.$set(item, "active", $$v)
                                              },
                                              expression: "item.active",
                                            },
                                          }),
                                          _c("v-switch", {
                                            attrs: {
                                              label: "Run contingency",
                                              hint: "Consider this transformer in an n-1 contingency analysis",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value: item.run_contingency,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "run_contingency",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.run_contingency",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .hv_node_rated_voltage.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .hv_node_rated_voltage.unit,
                                          type: "number",
                                          disabled: _vm.disable,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.hv_node_rated_voltage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "hv_node_rated_voltage",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "item.hv_node_rated_voltage",
                                        },
                                      }),
                                      item.winding === "three"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.schemaTransformer3w
                                                  .mv_node_rated_voltage.title,
                                              suffix:
                                                _vm.schemaTransformer3w
                                                  .mv_node_rated_voltage.unit,
                                              type: "number",
                                              disabled: _vm.disable,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.mv_node_rated_voltage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "mv_node_rated_voltage",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "item.mv_node_rated_voltage",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .lv_node_rated_voltage.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .lv_node_rated_voltage.unit,
                                          type: "number",
                                          disabled: _vm.disable,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.lv_node_rated_voltage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "lv_node_rated_voltage",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "item.lv_node_rated_voltage",
                                        },
                                      }),
                                      item.winding === "two"
                                        ? [
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .rated_apparant_power.title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .rated_apparant_power.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.rated_apparant_power,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "rated_apparant_power",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.rated_apparant_power",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .short_circuit_voltage
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .short_circuit_voltage.unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.short_circuit_voltage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "short_circuit_voltage",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.short_circuit_voltage",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .short_circuit_real_voltage
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .short_circuit_real_voltage
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.short_circuit_real_voltage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "short_circuit_real_voltage",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.short_circuit_real_voltage",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .max_loading_percent.title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .max_loading_percent.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.max_loading_percent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "max_loading_percent",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.max_loading_percent",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .phase_shift_angle.title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .phase_shift_angle.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.phase_shift_angle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "phase_shift_angle",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.phase_shift_angle",
                                              },
                                            }),
                                          ]
                                        : _vm._e(),
                                      item.winding === "three"
                                        ? [
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .hv_node_rated_apparent_power
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .hv_node_rated_apparent_power
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.hv_node_rated_apparent_power,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "hv_node_rated_apparent_power",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.hv_node_rated_apparent_power",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .mv_node_rated_apparent_power
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .mv_node_rated_apparent_power
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.mv_node_rated_apparent_power,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "mv_node_rated_apparent_power",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.mv_node_rated_apparent_power",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .lv_node_rated_apparent_power
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .lv_node_rated_apparent_power
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.lv_node_rated_apparent_power,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "lv_node_rated_apparent_power",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.lv_node_rated_apparent_power",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_hv_to_mv.title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_hv_to_mv.unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.SC_voltage_hv_to_mv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_voltage_hv_to_mv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_voltage_hv_to_mv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_mv_to_lv.title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_mv_to_lv.unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.SC_voltage_mv_to_lv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_voltage_mv_to_lv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_voltage_mv_to_lv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_hv_to_lv.title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_voltage_hv_to_lv.unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.SC_voltage_hv_to_lv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_voltage_hv_to_lv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_voltage_hv_to_lv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_hv_to_mv
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_hv_to_mv
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.SC_real_voltage_hv_to_mv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_real_voltage_hv_to_mv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_real_voltage_hv_to_mv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_mv_to_lv
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_mv_to_lv
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.SC_real_voltage_mv_to_lv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_real_voltage_mv_to_lv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_real_voltage_mv_to_lv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_hv_to_lv
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .SC_real_voltage_hv_to_lv
                                                    .unit,
                                                type: "number",
                                                disabled: _vm.disable,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.SC_real_voltage_hv_to_lv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "SC_real_voltage_hv_to_lv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.SC_real_voltage_hv_to_lv",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .mv_phase_shift_angle.title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .mv_phase_shift_angle.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.mv_phase_shift_angle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "mv_phase_shift_angle",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.mv_phase_shift_angle",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer3w
                                                    .lv_phase_shift_angle.title,
                                                suffix:
                                                  _vm.schemaTransformer3w
                                                    .lv_phase_shift_angle.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.lv_phase_shift_angle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "lv_phase_shift_angle",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.lv_phase_shift_angle",
                                              },
                                            }),
                                          ]
                                        : _vm._e(),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer.iron_losses
                                              .title,
                                          suffix:
                                            _vm.schemaTransformer.iron_losses
                                              .unit,
                                          type: "number",
                                          disabled: _vm.disable,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.iron_losses,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "iron_losses",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.iron_losses",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .open_loop_losses.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .open_loop_losses.unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.open_loop_losses,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "open_loop_losses",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.open_loop_losses",
                                        },
                                      }),
                                    ],
                                    2
                                  ),
                                  _c("v-card-title", [
                                    _c("h6", { staticClass: "text-h6" }, [
                                      _vm._v("Tap Changer Parameters"),
                                    ]),
                                  ]),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .ideal_phase_shifter.title,
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.ideal_phase_shifter,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "ideal_phase_shifter",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.ideal_phase_shifter",
                                        },
                                      }),
                                      _c("v-select", {
                                        attrs: {
                                          clearable: "",
                                          items:
                                            _vm.transformerTapChangerSideItems(
                                              item
                                            ),
                                          label:
                                            _vm.schemaTransformer
                                              .tap_changer_side.title,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.tap_changer_side,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "tap_changer_side",
                                              $$v
                                            )
                                          },
                                          expression: "item.tap_changer_side",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .rated_tap_position.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .rated_tap_position.unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.rated_tap_position,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "rated_tap_position",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.rated_tap_position",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .min_tap_position.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .min_tap_position.unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.min_tap_position,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "min_tap_position",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.min_tap_position",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .max_tap_position.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .max_tap_position.unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.max_tap_position,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "max_tap_position",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.max_tap_position",
                                        },
                                      }),
                                      _c(
                                        "v-row",
                                        [
                                          item.ideal_phase_shifter
                                            ? _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      attrs: { column: "" },
                                                      model: {
                                                        value: _vm.tapStep,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.tapStep = $$v
                                                        },
                                                        expression: "tapStep",
                                                      },
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label:
                                                            "Tap Step Size for Voltage Angle",
                                                          value: "angle",
                                                        },
                                                      }),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label:
                                                            "Tap Step Size for Voltage Magnitude",
                                                          value: "magnitude",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-col",
                                            [
                                              !item.ideal_phase_shifter ||
                                              _vm.tapStep === "angle"
                                                ? _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        _vm.schemaTransformer
                                                          .tap_step_size_degree
                                                          .title,
                                                      suffix:
                                                        _vm.schemaTransformer
                                                          .tap_step_size_degree
                                                          .unit,
                                                      type: "number",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "change"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        item.tap_step_size_degree,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "tap_step_size_degree",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.tap_step_size_degree",
                                                    },
                                                  })
                                                : _vm._e(),
                                              !item.ideal_phase_shifter ||
                                              _vm.tapStep === "magnitude"
                                                ? _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        _vm.schemaTransformer
                                                          .tap_step_size_percentage
                                                          .title,
                                                      suffix:
                                                        _vm.schemaTransformer
                                                          .tap_step_size_percentage
                                                          .unit,
                                                      type: "number",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "change"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        item.tap_step_size_percentage,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "tap_step_size_percentage",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.tap_step_size_percentage",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.schemaTransformer
                                              .tap_changer_position.title,
                                          suffix:
                                            _vm.schemaTransformer
                                              .tap_changer_position.unit,
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.tap_changer_position,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "tap_changer_position",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "item.tap_changer_position",
                                        },
                                      }),
                                      _c("v-select", {
                                        attrs: {
                                          items:
                                            _vm.schemaTransformer.vector_group.enum.filter(
                                              function (el) {
                                                return el !== null
                                              }
                                            ),
                                          hint: _vm.schemaTransformer
                                            .vector_group.tooltip,
                                          label:
                                            _vm.schemaTransformer.vector_group
                                              .title,
                                          disabled: _vm.disable,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.vector_group,
                                          callback: function ($$v) {
                                            _vm.$set(item, "vector_group", $$v)
                                          },
                                          expression: "item.vector_group",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  item.winding === "two"
                                    ? [
                                        _c("v-card-title", [
                                          _c("h6", { staticClass: "text-h6" }, [
                                            _vm._v("Short Circuit Parameters"),
                                          ]),
                                        ]),
                                        _c(
                                          "v-card-text",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .zs_voltage.title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .zs_voltage.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.zs_voltage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "zs_voltage",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "item.zs_voltage",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .zs_real_voltage.title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .zs_real_voltage.unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.zs_real_voltage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "zs_real_voltage",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.zs_real_voltage",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .zs_magnetizing_impedance
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .zs_magnetizing_impedance
                                                    .unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.zs_magnetizing_impedance,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "zs_magnetizing_impedance",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.zs_magnetizing_impedance",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .zs_magnetizing_rx_ratio
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .zs_magnetizing_rx_ratio
                                                    .unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.zs_magnetizing_rx_ratio,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "zs_magnetizing_rx_ratio",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.zs_magnetizing_rx_ratio",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.schemaTransformer
                                                    .hv_node_zs_impedance_distribution
                                                    .title,
                                                suffix:
                                                  _vm.schemaTransformer
                                                    .hv_node_zs_impedance_distribution
                                                    .unit,
                                                type: "number",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.hv_node_zs_impedance_distribution,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "hv_node_zs_impedance_distribution",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "item.hv_node_zs_impedance_distribution",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedInput.transformers,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "transformers", $$v)
                      },
                      expression: "computedInput.transformers",
                    },
                  },
                  "Aggregate",
                  _vm.$attrs,
                  false
                )
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "12" } },
            [
              _c(
                "Aggregate",
                _vm._b(
                  {
                    attrs: {
                      title: "Switches",
                      ItemConstructor: _vm.switchFactory,
                      headers: _vm.switchHeaders,
                      "copy-btn": "",
                      noExpand: "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.bus_id",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.bus_id,
                                  callback: function ($$v) {
                                    _vm.$set(item, "bus_id", $$v)
                                  },
                                  expression: "item.bus_id",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.element_type",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.switchElementTypeItems,
                                  "item-text": "text",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.element_type,
                                  callback: function ($$v) {
                                    _vm.$set(item, "element_type", $$v)
                                  },
                                  expression: "item.element_type",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.element",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.switchElementSelectionMethod(
                                    item.element_type
                                  ),
                                  "item-text": "text",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.element,
                                  callback: function ($$v) {
                                    _vm.$set(item, "element", $$v)
                                  },
                                  expression: "item.element",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.type",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.switchTypeItems,
                                  "item-text": "text",
                                  clearable: "",
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.type,
                                  callback: function ($$v) {
                                    _vm.$set(item, "type", $$v)
                                  },
                                  expression: "item.type",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.closed",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-switch", {
                                attrs: { dense: "" },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.closed,
                                  callback: function ($$v) {
                                    _vm.$set(item, "closed", $$v)
                                  },
                                  expression: "item.closed",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedInput.switches,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "switches", $$v)
                      },
                      expression: "computedInput.switches",
                    },
                  },
                  "Aggregate",
                  _vm.$attrs,
                  false
                )
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }